module.exports = __webpack_public_path__ + "img/icon-stock.831436f4.png";